import { render, staticRenderFns } from "./LayersTreeItem.vue?vue&type=template&id=2538ca98&scoped=true"
import script from "./LayersTreeItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayersTreeItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LayersTreeItem.vue?vue&type=style&index=0&id=2538ca98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538ca98",
  null
  
)

export default component.exports